import opmStore from '@/lib/storeOwnerProjectManager';
import { useRouter, useRoute } from 'vue-router';


function useButtonType(){
    const buttonType = (importance) => {
        switch (importance) {
            case 'primary':
                return 'flat';
            case 'secondary':
                return 'outlined';
            default:
                return 'text';
        }
    };
    return { buttonType };
}

// vm.props.label
function useButtonClick(pageData, form){
    const router = useRouter();
    // eslint-disable-next-line no-unused-vars
    const route = useRoute();

    const buttonClick = async (action) => {
        switch (action.type) {
            case 'link':
                router.push(action.href.replace(/^\/#/, '')); // Navigate to the cleaned href
            break;
            case 'api': {
                
                const formValidation = await form.value.validate();
                if (!formValidation.valid) {
                    let errors = `Please fix the form errors.`
                    formValidation.errors.forEach((error) => {
                        const item = form.value.items.find(element => element.id === error.id);
                        const errorLabel = item.vm.props.label;
                        errors += `<br/><br/><strong>${errorLabel}:</strong>`;
                        error.errorMessages.forEach((errorMessage) => {
                            errors += ` ${errorMessage}`;
                        });
                    });
                    opmStore.dispatch('setError', errors);
                    return;
                }
                
                // Need this for the 'key' below.
                // eslint-disable-next-line no-unused-vars
                const returnData = Object.entries(pageData.value).filter(([key, value]) => value?.isEditable).flatMap(([key, value]) => {
                    if(value.isArray){
                        const arraytoReturn = [];
                        value.value.map(item => {
                            const nestedObject = Object.entries(item).reduce((acc, [nestedKey, nestedValue]) => {
                                acc[nestedKey] = nestedValue.value; // Extract the nested `value`
                                return acc;
                            }, {});
                            arraytoReturn.push(nestedObject);``
                        });
                        return { key: key, value: arraytoReturn }; 
                    }
                    
                    return { key, value: value.value };
                });
                console.log('returnData',returnData)
                action.submitting = true;
                opmStore.dispatch('clearErrors');
                let dispatchAction;
                if(!route.params.fetch_type){
                    dispatchAction = 'postEntityData';
                }
                if(route.params.fetch_type === 'patch'){
                    dispatchAction = 'patchEntityData';
                }
                if(route.params.fetch_type === 'update'){
                    dispatchAction = 'putEntityData';
                }
                const response = await opmStore.dispatch(dispatchAction,{
                    endpoint: action.endpoint,
                    payload: returnData,
                });
                if(response?.success){
                    router.push(response.meta.redirect.replace(/^\/#/, ''));
                }
                action.submitting = false;
            break;
            }
        }
    };
    return { buttonClick };
}


export {
    useButtonType,
    useButtonClick
}